import { openProfile } from '../lib/nav';
import React from 'react';

const LINK_RE = /(https?:\/\/[^\s<>"')\]]+|www\.[a-z0-9-]+(?:\.[a-z0-9-]+)+[^\s<>"')\]]*)/gi;
const MENTION_RE = /(^|[^\w@/.])@([a-z0-9][a-z0-9-]{1,39})\b/gi;

const BOLD_RE = /\*\*([^*\n][^*]*?)\*\*/g;

/* **bold** as bold — the one bit of formatting people type everywhere. */
function Bolded({ text }) {
  const parts = (text || '').split(BOLD_RE);
  return parts.map((part, i) => (i % 2 === 1 ? <strong key={i}>{part}</strong> : part));
}

/* Links in a post are links. Clicking one must not also open the post. */
export function Linkified({ text }) {
  const parts = (text || '').split(LINK_RE);
  return parts.map((part, i) => {
    if (i % 2 === 0) return <Bolded key={i} text={part} />;
    const clean = part.replace(/[.,;:!?]+$/, '');
    const tail = part.slice(clean.length);
    const href = clean.startsWith('http') ? clean : `https://${clean}`;
    return (
      <React.Fragment key={i}>
        <a href={href} target="_blank" rel="noopener noreferrer nofollow" onClick={(e) => e.stopPropagation()}>
          {clean}
        </a>
        {tail}
      </React.Fragment>
    );
  });
}

/* Text with links, and @handles shown as the tagged person's name. A handle
   that isn't a live tag (removed, or never valid) stays as plain text. */
export default function RichText({ text, mentions = [] }) {
  const byHandle = Object.fromEntries((mentions || []).map((m) => [m.handle.toLowerCase(), m]));
  const out = [];
  let last = 0;
  const src = text || '';
  MENTION_RE.lastIndex = 0;
  let m;
  while ((m = MENTION_RE.exec(src)) !== null) {
    const person = byHandle[m[2].toLowerCase()];
    if (!person) continue;
    const start = m.index + m[1].length;
    out.push(<Linkified key={`t${last}`} text={src.slice(last, start)} />);
    out.push(
      <button type="button" key={`m${start}`} className="mention person-link" title={person.headline || person.name}
        onClick={(e) => { e.stopPropagation(); openProfile(person.handle); }}>@{person.name}</button>,
    );
    last = start + m[2].length + 1;
  }
  out.push(<Linkified key={`t${last}`} text={src.slice(last)} />);
  return out;
}
